"use client";
import React from "react";
import Image from "next/image";
import { Box, Stack, VStack } from "@chakra-ui/react";
import { useHeadingVariant } from "@/theme/hooks/useSectionStyle";
import { Heading } from "@/elements";
import { CERTIFICATES, CERTIFICATE_CONSTANTS } from "./certificate.constants";

const Certificates = ({ showHeading = true }: { showHeading?: boolean }) => {
  const HeadingVariant = useHeadingVariant();
  return (
    <VStack gap={4}>
      {showHeading && (
        <Heading as="h2" variant={HeadingVariant} textAlign={"center"}>
          {CERTIFICATE_CONSTANTS.TITLE}
        </Heading>
      )}
      <Stack
        borderRadius={"8px"}
        // className="brand-shadow"
        direction={{ base: "column", sm: "row" }}
        mt={6}
        p={4}
        gap={6}
      >
        {CERTIFICATES.map((certificate, index) => {
          return (
            <Box
              borderColor={"black"}
              borderRadius={"8px"}
              borderWidth={"1px"}
              key={index}
              p={4}
            >
              <Box
                height={{ base: "200px", sm: "150px", md: "160px" }}
                position="relative"
                width={{ base: "200px", sm: "150px", md: "200px" }}
              >
                <Image
                  alt={certificate.name}
                  title={certificate.name}
                  fill
                  placeholder="blur"
                  src={certificate.image}
                  sizes={"(max-width: 200px) 100vw, 200px"}
                  style={{ objectFit: "contain" }}
                />
              </Box>
            </Box>
          );
        })}
      </Stack>
    </VStack>
  );
};

export default Certificates;
